import {
    copilotTeachingPopoverStore,
    getAnchorIdKey,
    lazyInitializeCopilotTeachingPopoverState,
    IrisApiStatus,
} from 'owa-iris-store';
import { isAccountFeatureEnabled } from 'owa-feature-flags';
import { DatapointStatus, PerformanceDatapoint } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';
import { getCampaignId } from './getCampaignId';

let initializeCopilotTeachingStorePromise: Promise<void>;
export async function initializeCopilotTeachingStore(mailboxInfo: MailboxInfo): Promise<void> {
    if (
        isAccountFeatureEnabled('mon-copilot-teaching-popover', mailboxInfo) &&
        !initializeCopilotTeachingStorePromise
    ) {
        const initPerfDatapoint = new PerformanceDatapoint(
            'CopilotTeachingInitialization',
            mailboxInfo
        );

        const anchorIDKey = getAnchorIdKey(copilotTeachingPopoverStore().anchorID);

        // Initialize the Copilot Teaching Popover state
        initializeCopilotTeachingStorePromise = lazyInitializeCopilotTeachingPopoverState
            .importAndExecute(mailboxInfo, 'TeachingPopoverComponent', initPerfDatapoint)
            .then(async irisApiStatus => {
                if (irisApiStatus == IrisApiStatus.IRIS_AD_RECEIVED) {
                    const customData = {
                        title: copilotTeachingPopoverStore().title,
                        body: copilotTeachingPopoverStore().body,
                        prmId: copilotTeachingPopoverStore().irisPrmId,
                        anchorID: anchorIDKey,
                        campaignPid: getCampaignId(),
                    };
                    initPerfDatapoint.addCustomData(customData);
                }

                initPerfDatapoint.end();
            })
            .catch(err => {
                initPerfDatapoint.endWithError(DatapointStatus.ClientError, err);
            });
    }

    return initializeCopilotTeachingStorePromise;
}
